import "./index.css";
import { clsx } from "clsx";
import { CircleCheck, Info, OctagonX, TriangleAlert } from "lucide-react";
import { useBreakpoints } from "@/hooks/useBreakpoints";
import { Text } from "@/ui-kit";
import type { IAlertProps } from "./types";

const iconMap = {
  success: <CircleCheck size="1.25rem" />,
  warning: <TriangleAlert size="1.25rem" />,
  danger: <OctagonX size="1.25rem" />,
  info: <Info size="1.25rem" />,
};

const Alert = ({
  variant = "info",
  className,
  content,
  controls,
  title,
  icon,
  showIcon = true,
}: IAlertProps) => {
  const rootClass = clsx("nuco-alert", `nuco-color-${variant}`, className);
  const { isMobile } = useBreakpoints();

  return (
    <div className={rootClass}>
      <div className="nuco-alert__title-row">
        {showIcon && (
          <div className="nuco-alert__icon">{icon || iconMap[variant]}</div>
        )}
        <Text className="nuco-alert__title">{title}</Text>
        {!isMobile && <div className="nuco-alert__controls">{controls}</div>}
      </div>
      <div className="nuco-alert__content">{content}</div>
      {isMobile && <div className="nuco-alert__controls">{controls}</div>}
    </div>
  );
};

export default Alert;
